// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1kTMu","tab":"ProcedureTabs_tab___3M4r"};